import { useState } from "react";
import { validateField } from "../Valdations/validateField";
import { z, AnyZodObject } from "zod";

export const useGroupForm = <T extends AnyZodObject>(schema: T) => {
  type FormValues = z.infer<T>;
  type FieldKey = keyof FormValues;

  const [values, setValues] = useState<FormValues>({} as FormValues);
  const [errors, setErrors] = useState<Partial<Record<FieldKey, string>>>({});

  const setField = (field: FieldKey, value: any) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    const fieldSchema = (schema.shape as any)[field];
    if (fieldSchema) {
      const error = validateField(fieldSchema, value);
      setErrors((prev) => ({ ...prev, [field]: error || undefined }));
    }
  };

  const validateAll = () => {
    const result = schema.safeParse(values);
    if (!result.success) {
      const newErrors: any = {};
      result.error.issues.forEach((i) => {
        const key = i.path[0];
        newErrors[key] = i.message;
      });
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  return { values, errors, setField, validateAll, setValues };
};
